// ReportStatusBadge — status badges for reports (Rascunho, Em processamento, Gerado, Em revisão, Aprovado, Publicado, Com erro, Arquivado)
interface Props {
  status: string;
}

const statusConfig: Record<string, { bg: string; text: string; icon: string }> = {
  "Rascunho": { bg: "bg-background-200 text-foreground-600", text: "text-foreground-600", icon: "ri-draft-line" },
  "Em processamento": { bg: "bg-accent-100 text-accent-700", text: "text-accent-700", icon: "ri-loader-4-line" },
  "Gerado": { bg: "bg-primary-100 text-primary-700", text: "text-primary-700", icon: "ri-check-line" },
  "Em revisão": { bg: "bg-yellow-100 text-yellow-700", text: "text-yellow-700", icon: "ri-search-eye-line" },
  "Aprovado": { bg: "bg-primary-100 text-primary-700", text: "text-primary-700", icon: "ri-verified-badge-line" },
  "Publicado": { bg: "bg-primary-200 text-primary-800", text: "text-primary-800", icon: "ri-global-line" },
  "Com erro": { bg: "bg-red-100 text-red-700", text: "text-red-700", icon: "ri-error-warning-line" },
  "Arquivado": { bg: "bg-background-200 text-foreground-500", text: "text-foreground-500", icon: "ri-archive-line" },
};

export default function ReportStatusBadge({ status }: Props) {
  const c = statusConfig[status] || { bg: "bg-background-100 text-foreground-500", text: "text-foreground-500", icon: "ri-question-line" };
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${c.bg}`}>
      <i className={`${c.icon} w-3 h-3 flex items-center justify-center`} />
      {status}
    </span>
  );
}